module.exports = __webpack_public_path__ + "img/DO.c0138719.png";